import { Component, OnInit } from '@angular/core';
import { AdDataService } from '../services/addata.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private adservice: AdDataService) { }

  ngOnInit() {
    sessionStorage.removeItem('freedays');
    sessionStorage.removeItem('noOfAdDays');
    sessionStorage.removeItem('selectedDate');
    sessionStorage.removeItem('Array');
  }

  navigatetoad(type: string) {
    this.adservice.setAdData(null);
    this.adservice.initialize();
    this.adservice.setAdType(type);
  }

}
